(function($){
    $(document).ready(function() {
        function setFbWidgetsClasses() {
            var $sidebar = $('aside.sidebar');

            $sidebar.each(function(key,value) {
                var $widget_fbw_id = $(value).find('.widget_fbw_id');
                $widget_fbw_id.each(function(key,value) {
                    $(value).addClass('facebook-widget fb-widget-' + key);
                });
            });
        }

        function setInstagrammWidgetsClasses() {
            var instagramWidget = $('.AlpinePhotoTiles_inpost_container');
            instagramWidget.closest('section').addClass('instagram-widget');
        }

        setFbWidgetsClasses();
        setInstagrammWidgetsClasses();
    });
})(jQuery);
